var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13782_122771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4737 56.4346C64.8971 52.8551 59.0943 52.8551 55.5177 56.4346C42.2381 69.7143 35.7111 88.2135 37.6079 107.192C38.0812 111.92 42.0642 115.445 46.7156 115.445C47.0213 115.445 47.3293 115.429 47.635 115.399C52.6715 114.895 56.3455 110.402 55.8417 105.369C54.4918 91.8812 59.0977 78.7668 68.4737 69.3902C72.0533 65.8141 72.0533 60.0108 68.4737 56.4346Z",
    fill: "#B7C2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.759 0C46.9945 0 0 46.9945 0 104.759C0 162.523 46.9945 209.517 104.759 209.517C162.523 209.517 209.517 162.523 209.517 104.759C209.517 46.9945 162.522 0 104.759 0ZM104.759 191.192C57.0981 191.192 18.3254 152.419 18.3254 104.759C18.3254 57.0981 57.0981 18.3254 104.759 18.3254C152.416 18.3254 191.192 57.0981 191.192 104.759C191.192 152.419 152.419 191.192 104.759 191.192Z",
    fill: "#B7C2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.316 232.36L178.734 165.778C175.155 162.199 169.358 162.199 165.778 165.778C162.199 169.355 162.199 175.158 165.778 178.734L232.36 245.316C234.15 247.105 236.492 248 238.838 248C241.184 248 243.526 247.105 245.316 245.316C248.895 241.739 248.895 235.936 245.316 232.36Z",
    fill: "#B7C2C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13782_122771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 248,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/no-result.94e831c5cadfc4ea4e6f0c8734f2e8f9.svg";
export { ForwardRef as ReactComponent };